import ActionTypes from '../constants';

const initialState = {
    estimates: {},
    parallelEstimates: {},
    estimate: {},
    estimateSaved: {},
    
    // loading: false,
};

const estimateReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETESTIMATESUCCESS:
            return {
                ...state,
                estimates: action.payload,
            }
        case ActionTypes.GETPARALLELESTIMATESUCCESS:
            return {
                ...state,
                parallelEstimates: action.payload,
            }
        case ActionTypes.GETESTIMATEBYIDSUCCESS:
            return {
                ...state,
                estimate: action.payload,
            }
        case ActionTypes.GETESTIMATEBYINVESTIGATIONIDSUCCESS:
            return {
                ...state,
                estimateSaved: action.payload,
            }
        default:
            return state;
    }
}

export default estimateReducer;